/* eslint-disable */
/* prettier-ignore-start */
// [GENERATED FILE; DO NOT EDIT BY HAND]

import React from "react"

var element = React.createElement("svg", {
  width: "40",
  height: "20",
  viewBox: "0 0 40 20",
  fill: "currentColor",
  "aria-hidden": "true"
}, React.createElement("path", {
  d: "M0 8a8 8 0 018-8h11c4.42 0 8 3.58 8 8v4a8 8 0 01-8 8H8c-4.42 0-8-3.58-8-8V8zm13.5 5.33c1.86 0 3.38-1.49 3.38-3.33a3.35 3.35 0 00-3.38-3.33A3.35 3.35 0 0010.12 10a3.35 3.35 0 003.38 3.33zM40 .62v18.76c0 .66-.47.82-1.04.35l-6.9-5.63c-2.78-2.26-2.79-5.93 0-8.2l6.9-5.63C39.54-.2 40-.04 40 .62z",
  fillRule: "evenodd"
}));

var Svg = React.forwardRef(function (props, ref) {
  var next = { ref: ref };
  for (var key in props) {
    if (props.hasOwnProperty(key)) {
      next[key] = props[key];
    }
  }
  return React.cloneElement(element, next);
});
Svg.displayName = "Cine";
Svg.element = element;
export default Svg;
